import PropTypes from 'prop-types'
import InterventionsSubheader from 'components/admin/Interventions/Subheader'
import SiteView from 'components/admin/Interventions/SiteView'
import TierLabel from 'components/TierLabel'
import {
  K8Tier2ViewContainer,
  LastUpdatedAtText,
  LoadingMessage,
  SiteHeader,
  TierPill,
  Title,
  TitleWrapper,
} from './component.styles'
import { HEADER_TEXT, LOADING_TEXT, TIER_2_LABEL_TEXT } from './constants'

const AdminK8Tier2View = ({ summary, tier2DashboardSites, isFetching }) => {
  if (!Array.isArray(tier2DashboardSites) || tier2DashboardSites.length < 1) {
    return null
  }

  const site = tier2DashboardSites?.[0] || {}

  return (
    <K8Tier2ViewContainer key={site.siteId}>
      <SiteHeader>
        <TitleWrapper>
          <Title>{HEADER_TEXT}</Title>
          <TierPill>
            <TierLabel labelText={TIER_2_LABEL_TEXT} />
          </TierPill>
        </TitleWrapper>
        <InterventionsSubheader summary={summary} />
      </SiteHeader>
      <LastUpdatedAtText>{summary.lastUpdatedAt}</LastUpdatedAtText>
      <SiteView isSingleSite={true} site={site} />
      {isFetching && <LoadingMessage>{LOADING_TEXT}</LoadingMessage>}
    </K8Tier2ViewContainer>
  )
}

AdminK8Tier2View.propTypes = {
  isFetching: PropTypes.bool,
  summary: PropTypes.shape({
    groupsThatHaventCompletedLesson: PropTypes.number.isRequired,
    lessonsCompleted: PropTypes.number.isRequired,
    numberOfSites: PropTypes.number.isRequired,
    lastUpdatedAt: PropTypes.string,
    smallGroupsCreated: PropTypes.number.isRequired,
  }).isRequired,
  tier2DashboardSites: PropTypes.arrayOf(
    PropTypes.shape({
      gradeBandData: PropTypes.array,
      siteId: PropTypes.number.isRequired,
    }),
  ).isRequired,
}

export default AdminK8Tier2View
